// removed by extract-text-webpack-plugin
module.exports = {"base":"PlayersMatchingButton_base--1LHbx","base__disabled":"PlayersMatchingButton_base__disabled--2_qfY","baseDisabled":"PlayersMatchingButton_base__disabled--2_qfY","reason":"PlayersMatchingButton_reason--1N0x0"};


//////////////////
// WEBPACK FOOTER
// ./containers/BattleRooms/containers/PlayersMatchingView/components/PlayersMatchingButton/PlayersMatchingButton.scss
// module id = 460
// module chunks = 11 12